import getTableColumnCountForCells from '../utils/getTableColumnCountForCells';
var MAX_TABLE_COLUMN_COUNT = 100;
export default function canAddTableColumn(editor, tableId) {
  var cells = editor.getTableCells(tableId);
  var columnCount = getTableColumnCountForCells(cells);
  return columnCount < MAX_TABLE_COLUMN_COUNT;
}